<template>
	<div class="second-head flex  space-between">
		<div class="flex ">
			<a href="/">
				<img v-if="$functions.isFoTon()" src="../assets/foton/foton56black.png" alt="" class="logo" />
        		<img v-else src="../assets/logo_small2.png" alt="" class="logo" />
			</a>
			<el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" :text-color="textColor">
				<el-menu-item index="1" v-show="permissionList.admin1001">
					<router-link to="my" :style="{ color: color }">{{$t('main.MyQuestionnaire')}}</router-link>
					<span></span>
				</el-menu-item>
				<el-menu-item index="4" v-show="permissionList.admin1002">
					<router-link to="myExam">{{$t('main.MyExam')}}</router-link>
					<span></span>
				</el-menu-item>
				<!-- 	<el-menu-item index="2">
					<router-link to="template">问卷模板</router-link>
					<span></span>
				</el-menu-item>
				<el-menu-item index="3">
					<a @click="tocreate()">设计问卷</a>
					<span></span>
				</el-menu-item> -->
				<el-menu-item index="6" v-show="permissionList.admin1003">
					<router-link to="managementIndex" :style="{ color: color }">{{$t('main.QuesLibrary')}}</router-link>
					<span></span>
				</el-menu-item>
				<el-menu-item index="8" v-show="permissionList.admin1004">
					<router-link to="examQuestionBank" :style="{ color: color }">{{$t('main.ExamQuestionBank')}}</router-link>
					<span></span>
				</el-menu-item>
				<el-menu-item index="7" v-show="permissionList.admin1005">
					<router-link to="managementUser" :style="{ color: color }">{{$t('main.UserManagement')}}</router-link>
					<span></span>
				</el-menu-item>
				<el-menu-item index="9" v-show="permissionList.admin1037">
					<router-link to="systemSettings" :style="{ color: color }">系统设置</router-link>
					<span></span>
				</el-menu-item>
			</el-menu>
		</div>
		<div class="flex ">
			<div style="margin-left: 30px">
				<el-dropdown @command="handleCommand">
					<div class="user-info">
						<span class="el-dropdown-link set">
							<img v-if="userInfo.heaPath && userInfo.heaPath != 'touxiang.png'" :src="userInfo.heaPath" alt="" class="user" />
							<img v-else src="../assets/default-imgs/touxiang.png" alt="" class="user" />
						</span>
						<span class="nick-name">{{ userInfo.nickname }}</span>
						<i class="el-icon-arrow-down el-icon--right"></i>
					</div>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item icon="iconfont icon-icon-" command="0">{{$t('main.userInformation')}}</el-dropdown-item>
						<el-dropdown-item icon="wjpc-iconfont wjpc-icon-tiku" command="5">{{$t('main.myDownloads')}}</el-dropdown-item>
						<el-dropdown-item icon="wjpc-iconfont wjpc-icon-qianbao" command="6">{{$t('main.myWallet')}}</el-dropdown-item>
						<!-- <el-dropdown-item icon="wjpc-iconfont wjpc-icon-erji" command="1">{{$t('main.CustomerServiceCenter')}}</el-dropdown-item> -->
						<el-dropdown-item icon="wjpc-iconfont wjpc-icon-lianxirenicon-02-copy" command="3">{{$t('main.liaison')}}</el-dropdown-item>
						<!-- <el-dropdown-item icon="wjpc-iconfont wjpc-icon-shezhi" command="4">{{$t('main.advancedSetting')}}</el-dropdown-item> -->
						<el-dropdown-item icon="iconfont icon-tuichu" command="2">{{$t('login.LogOutOfLogin')}}</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</div>
    <HeadFooter></HeadFooter>
	</div>
</template>

<script>
import HeadFooter from "@/components/HeadFooter";
export default {
	name: 'SecondHead',
	components: {
		HeadFooter,
	},
	props: ['activeIndex', 'textColor', 'color'],
	data() {
		return {
			permissionList: {},
			userInfo: {}
		};
	},
	created() {
		this.loadData();
		this.accessPermission();
	},
	methods: {
		accessPermission() {
			let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
			if (userInfo && userInfo.permissionList.length > 0) {
				let arr = userInfo.permissionList;
				let permissionList = {};
				arr.forEach((item, index) => {
					permissionList['admin' + item] = item;
				});
				this.permissionList = permissionList;
			} else {
				this.getUserInfo()
			}
		},
		// 培训系统跳过来后需要重新获取权限
		getUserInfo() {
			let that = this;
			let params = {
				url: this.$config.service.getAllUserBaseInfo,
				data: {},
				that: this,
				cb(res) {
					if (res.code == 0) {
						that.userInfo = res.resultBody;
						if (that.userInfo.usertype == 1) {
							if (that.userInfo.permissionList.length == 0) {
								that.userInfo.permissionList = [
									'1022',
									'1021',
									'1020',
									'1019',
									'1018',
									'1017',
									'1016',
									'1015',
									'1014',
									'1036',
									'1013',
									'1035',
									'1034',
									'1012',
									'1011',
									'1033',
									'1010',
									'1032',
									'1031',
									'1030',
									'1008',
									'1007',
									'1029',
									'1006',
									'1028',
									'1027',
									'1005',
									'1026',
									'1004',
									'1025',
									'1003',
									'1002',
									'1024',
									'1001',
									'1023',
									'1009'
								];
							}
						}
						let arr = that.userInfo.permissionList;
						let permissionList = {};
						arr.forEach((item, index) => {
							permissionList['admin' + item] = item;
						});
						that.permissionList = permissionList;
						window.localStorage.setItem('userInfo', JSON.stringify(that.userInfo));
					}
				}
			};
			that.$util.request(params);
		},
		tocreate() {
			sessionStorage.setItem('wid', 0);
			setTimeout(() => {
				this.$router.replace({ path: '/wjedit1', query: { id: '1' } });
			}, 400);
		},
		handleSelect(key, keyPath) {
			console.log('用户', key, keyPath);
		},
		handleCommand(command) {
			switch (command) {
				case '0':
					this.$router.push({ path: '/personal' });
					break;
				case '1':
					break;
				case '2':
					let lang = window.localStorage.getItem('lang') || this.$defaultLang;
					console.log('lang :>> ', lang);
					window.localStorage.clear();
					window.localStorage.setItem('lang', lang)
					if (window.ssoswitch == 'on') {
						window.location.href = VUE_APP_CAS_BASE_URL + '/logout';
					} else {
						this.$router.push({ path: '/login' });
					}
					break;
				case '3':
					this.$router.push({ path: '/contant' });
					break;
				case '4':
					this.$router.push({ path: '/setting' });
					break;
				case '5':
					this.$router.push({ path: '/MyProject' });
					break;
				case '6':
					this.$router.push({ path: '/Mywallet' });
					break;
				default:
					break;
			}
		},
		loadData() {
			let that = this;
			let params = {
				url: this.$config.service.getAllUserBaseInfo,
				data: {},
				that: this,
				cb(res) {
					if (res.code == 0) {
						that.userInfo = res.resultBody;
						if (that.userInfo.usertype == 1) {
							if (that.userInfo.permissionList.length == 0) {
								that.userInfo.permissionList = [
									'1022',
									'1021',
									'1020',
									'1019',
									'1018',
									'1017',
									'1016',
									'1015',
									'1014',
									'1036',
									'1013',
									'1035',
									'1034',
									'1012',
									'1011',
									'1033',
									'1010',
									'1032',
									'1031',
									'1030',
									'1008',
									'1007',
									'1029',
									'1006',
									'1028',
									'1027',
									'1005',
									'1026',
									'1004',
									'1025',
									'1003',
									'1002',
									'1024',
									'1001',
									'1023',
									'1009'
								];
							}
						}
						window.localStorage.setItem('userInfo', JSON.stringify(that.userInfo));
					} else if(res.code == 1001) {
						that.handleCommand('2')
					}
				}
			};
			that.$util.request(params);
		}
	}
};
</script>

<style lang="scss" scoped>
.second-head {
	.flex {
		align-items: center;
	}
	.set {
		font-size: 14px;
		color: #666;
		cursor: pointer;
	}

	.menu {
		width: 100%;
	}
	.menu-item {
		font-size: 18px;
	}
	.el-menu--horizontal > .el-menu-item {
		font-size: 18px !important;
	}
	.el-menu {
		background: transparent;
	}
	.el-menu-item {
		margin-left: 25px !important;
	}
	.el-menu.el-menu--horizontal {
		border-bottom: solid 1px transparent;
	}
	.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
	.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
	.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
		background-color: transparent;
		color: #333;
	}
	.el-menu--horizontal > .el-menu-item.is-active {
		border-bottom: 0px solid #409eff;
		color: #333;
		position: relative;
	}
	.el-menu--horizontal > .el-menu-item.is-active span {
		display: block;
		position: absolute;
		width: 26px;
		height: 4px;
		border-radius: 2px;
		background: #409eff;
		left: 50%;
		top: 90%;
		transform: translate(-50%, -50%);
	}

	.logo {
		width: 54px;
		margin-right: 10px;
		cursor: pointer;
	}

	.user {
		display: block;
		width: 32px;
		height: 32px;
		border-radius: 50%;
		cursor: pointer;
		border: 1px solid #eee;
	}
	.user-info{
		cursor: pointer;
		display: flex;
		align-items: center;
		background: #ecf5ff;
    	border-radius: 18px;
		padding: 2px 10px 2px 2px;
		.nick-name{
			margin-left: 10px;
			padding-right: 10px;
		}
	}
}
</style>
